import styled from "styled-components/macro";

const Wrapper = styled.div`
  .breadcrumb-nav {
    text-decoration: none;
  }

  .breadcrumb-nav: hover {
    color: #e6236d;
    cursor: pointer;
  }
`;

export default Wrapper;
